import { render, staticRenderFns } from "./MomentShow.vue?vue&type=template&id=4fc82d9e&scoped=true"
import script from "./MomentShow.vue?vue&type=script&lang=js"
export * from "./MomentShow.vue?vue&type=script&lang=js"
import style0 from "./MomentShow.vue?vue&type=style&index=0&id=4fc82d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc82d9e",
  null
  
)

export default component.exports